export const LOCAL_CHAT_ACTIONS = {
  OPEN_CHAT: "OPEN_LOCAL_CHAT",
  CLOSE_CHAT: "CLOSE_LOCAL_CHAT"
};

export const LOCAL_CHAT_TOOLTIP = "Chat interno";

export const FIREBASE_COLLECTIONS = {
  CHATS: "chats",
  MESSAGES: "messages",
  USERS: "users",
  CLIENTS: "clients"
};

export const LOCAL_CHAT_TYPE = {
  GROUP: "group",
  DIRECT: "direct"
};

export const FIREBASE_EVENTS = {
  ADDED: "added",
  MODIFIED: "modified"
};

export const CHATS_FIELDS = {
  DATE_LAST_MESSAGE: "dateLastMessage",
  DATE_SENT: "dateSent",
  MEMBERS: "members",
  DEPENDENCY: "dependency"
};

export const CHAT_MESSAGES = {
  ERROR_DIRECT_LOAD: "Error al obtener chats directos: ",
  ERROR_GROUP_LOAD: "Error al obtener chats grupales: ",
  ERROR_USER_LOAD: "Error al obtener información del usuario: "
};
